import { Language } from "./doctor";
import { UserLocation } from "./location.definition";

export type UserInfo = {
  id?: string;
  photoUrl: string;
  email: string | null;
  civility?: CivilityType;
  roleName: RoleType;
  firstName: string;
  phoneNumber: string | null;
  lastName: string;
  paymentPhoneNumber?: string;
  preferredNotificationMethods: NotificationPrefType[];
  dateOfBirth?: string;
  locations?: UserLocation[];
  gender?: CivilityType;
  settings: UserSettings;
  requiresPasswordChange?: boolean;
};

export type UserSettings = {
  settingsId?: number;
  userId?: number;
  theme: Theme;
  timeZone: TimeZone;
  visibility: Visibility;
  appLanguage: Language;
  notifications: Notification[];
};

export type NotificationDoctorKey =
  | "appointments"
  | "messages"
  | "reviews"
  | "updates"
  | "marketing"
  | "reminders";

export type NotificationPatientKey =
  | "appointments"
  | "messages"
  | "marketing"
  | "reminders";

export type Notification =
  (typeof NotificationEnum)[keyof typeof NotificationEnum];

export const NotificationEnum = {
  APPOINTMENTS: "APPOINTMENTS",
  MESSAGES: "MESSAGES",
  REVIEWS: "REVIEWS",
  UPDATES: "UPDATES",
  REMINDERS: "REMINDERS",
  MARKETING: "MARKETING",
};

export type Visibility = (typeof VisibilityEnum)[keyof typeof VisibilityEnum];

export const VisibilityEnum = {
  PUBLIC: "PUBLIC",
  PRIVATE: "PRIVATE",
  DOCTORS_ONLY: "DOCTORS_ONLY",
  REGISTERED_USERS_ONLY: "REGISTERED_USERS_ONLY",
};

export type TimeZone = (typeof TimeZoneEnum)[keyof typeof TimeZoneEnum];

export const TimeZoneEnum = {
  UTC: "UTC",
  EASTERN_TIME: "EASTERN_TIME",
  CENTERAL_TIME: "CENTERAL_TIME",
  MONTAIN_TIME: "MONTAIN_TIME",
  PACIFIC_TIME: "PACIFIC_TIME",
};

export type Theme = (typeof ThemeEnum)[keyof typeof ThemeEnum];

export const ThemeEnum = {
  LIGHT: "LIGHT",
  DARK: "DARK",
  SYSTEM: "SYSTEM",
};

export type CivilityType = (typeof CivilityEnum)[keyof typeof CivilityEnum];

export const CivilityEnum = {
  MRS: "WOMAN",
  MR: "MAN",
};

export type NotificationPrefType =
  (typeof NotificationPrefEnum)[keyof typeof NotificationPrefEnum];

export const NotificationPrefEnum = {
  SMS: "SMS",
  EMAIL: "EMAIL",
};
export type RoleType = (typeof RoleEnum)[keyof typeof RoleEnum];

export const RoleEnum = {
  ADMIN: "ADMIN",
  PATIENT: "PATIENT",
  DOCTOR: "DOCTOR",
  MANAGER: "MANAGER",
  SECRETARY: "SECRETARY",
  SUPER_ADMIN: "SUPER_ADMIN",
};
export type EditableUserInfo = Omit<
  UserInfo,
  "preferredNotificationMethods"
> & {
  preferredNotificationMethods: {
    value: NotificationPrefType;
    label: NotificationPrefType;
  }[];
};
